import styled from "@emotion/styled";
import {ReactComponent as iconBlue} from "../../../../images/800CallLogs/Resources for Popup/IconBlue.svg"

export const IconBlue = styled(iconBlue)`
     width: 8px;
     height: 8px;
`;